import React from "react";
import styled from 'styled-components';
import {ColorWrap, Hue, Saturation} from "react-color/lib/components/common";
import {Col, Row, Space} from "antd";
import {HexInput} from "./HexInput";
import {SelectedColor} from "./SelectedColor";
import {SelectableColor} from "./SelectableColor";

const colors1 = [
    '#f5f5f5',
    '#ffccc7', '#ffd8bf', '#ffe7ba',
    '#fff1b8', '#ffffb8', '#f4ffb8',
    '#d9f7be', '#b5f5ec', '#bae7ff',
    '#d6e4ff', '#efdbff', '#ffd6e7',

];

const colors2 = [
    '#262626', '#cf1322', '#fa541c',
    '#d46b08', '#d48806', '#d4b106',
    '#5b8c00', '#389e0d', '#006d75',
    '#0050b3', '#10239e', '#531dab',
    '#9e1068',
];

const StyledRow = styled(Row)`
  .bukku-saturation {
    width: 100%;
    padding-bottom: 75%;
    overflow: hidden;
  }

  .bukku-hue, .bukku-alpha {
    height: 32px;
    border-radius: 2px;

    /* Picker */
    .hue-horizontal div div {
      height: 32px !important;
      margin-top: 0 !important;
      border-radius: 0 !important;
    }
  }
`;

const BukkuSaturation = ColorWrap(Saturation);
const BukkuHue = ColorWrap(Hue);

export function ColorPicker(props) {
    const { value, onChange } = props;

    function onFormColorChange(color) {
        onChange(color.hex);
    }

    const commonProps = {
        color: value,
        onChange: onFormColorChange,
    };

    return (
        <StyledRow gutter={[0, 8]}>
            <Col span={24} className="bukku-saturation">
                <BukkuSaturation {...commonProps} />
            </Col>
            <Col span={24} className="bukku-hue">
                <BukkuHue {...commonProps} />
            </Col>
            <Col span={24}>
                <Row gutter={[8, 0]}>
                    <Col span={16}>
                        <HexInput {...props} />
                    </Col>
                    <Col span={8}>
                        <SelectedColor value={value} />
                    </Col>
                </Row>
            </Col>
            <Col span={24}>
                <Space size={[4, 4]} wrap>
                    { colors1.map(color => <SelectableColor
                        color={color}
                        onChange={onChange}
                        key={color}
                    />) }
                </Space>
            </Col>
            <Col span={24}>
                <Space size={[4, 4]} wrap>
                    { colors2.map(color => <SelectableColor
                        color={color}
                        onChange={onChange}
                        isDark
                        key={color}
                    />) }
                </Space>
            </Col>
        </StyledRow>
    );
//
//
//     {/*<SketchPicker*/}
//     {/*    color={value}*/}
//     {/*    presetColors={colorOptions}*/}
//     {/*    onChange={!readOnly? onFormColorChange : null}*/}
//     {/*    onChangeComplete={!readOnly? onFormColorChange : null}*/}
//     {/*    styles={{*/}
//     {/*        picker: {},*/}
//     {/*        hue: {*/}
//     {/*            height: 24,*/}
//     {/*            position: 'relative',*/}
//     {/*            overflow: 'hidden'*/}
//     {/*        },*/}
//     {/*        Hue: {*/}
//     {/*            height: 24,*/}
//     {/*        },*/}
//     {/*        alpha: {*/}
//     {/*            height: 24,*/}
//     {/*            position: 'relative',*/}
//     {/*            overflow: 'hidden',*/}
//     {/*            marginTop: 4,*/}
//     {/*        },*/}
//     {/*        Alpha: {*/}
//     {/*            height: 24,*/}
//     {/*        },*/}
//     {/*    }}*/}
//     {/*/>*/}
//     // </Styled>
}
